import { httpClient } from './http-client';

const BASE_URL = '/api/invoice-info';

export type GetInvoiceInfoResponse = {
	hosted_invoice_url: string;
	invoice_pdf: string;
	total: number;
};

const getInvoiceInfo = async (invoiceId: string) => {
	return httpClient.get<GetInvoiceInfoResponse>(BASE_URL, { params: { invoice_id: invoiceId } });
};

export const invoiceInfoApi = {
	getInvoiceInfo,
};
